<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.41421 7.00023L13.364 2.05048L11.9497 0.636271L7 5.58602L2.05025 0.636271L0.636039 2.05048L5.58579 7.00023L0.636039 11.95L2.05025 13.3642L7 8.41445L11.9497 13.3642L13.364 11.95L8.41421 7.00023Z" fill="currentColor"/>
    </svg>
</template>